module.exports = __webpack_public_path__ + "static/media/power-bump-black-es.55651630.png";